import Highcharts from 'highcharts'
import HC_exporting from 'highcharts/modules/exporting'
import { useEffect, useState } from "react"
import { useParams, Link } from "react-router-dom"
import HighchartsReact from 'highcharts-react-official'

import Brands from '../../../DoHzel/Brands/Index'

import {
    ThreatDBIOC
} from '../../../../Templates/ThreatDBIOC'

import Statistic from "../../../../Templates/Statistic"

import {
    Card,
    Flex,
    Select,
    Row,
    Col,
    Spin,
    Table,
    Typography,
    Button,
    message,
    Space
} from 'antd'

import {
    DiventryBlock
} from '../../../../Templates/Layout'

import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { setTag } from '@sentry/react'

HC_exporting(Highcharts);

const DeviceTypes = {
    appleMac: "Apple MacOS",
    appleiOS: "Apple iOS",
    googleAndroid: "Google Android",
    windows: "Windows",
    linux: "Linux",
    freeBSD: "FreeBSD",
    proxy: "DoHzel Proxy",
    opnSense: "OPNsense",
    fritz: "FritZ! Box",
    browser: "Browser"
}

const statColors = {
    all: '#3498db',
    blocking: "#7c1f15ff",
    detecting: '#f1c40f',
    // passing: '#16a085'
}

export function Statistics({ kernel }) {

    const { id } = useParams();
    const { t } = useTranslation();
    const [messageApi, contextHolder] = message.useMessage();

    const periodes = [
        { value: 'last24h', label: t('Statistics.last24h') },
        { value: 'last30d', label: t('Statistics.last30d') },
        { value: 'last90d', label: t('Statistics.last90d') },
    ]

    const initialGlobaux = [
        {
            name: 'Statistics.requests',
            value: 0,
            color: '#000000'
        },
        {
            name: 'Statistics.blockedRequests',
            value: 0,
            color: '#941010cf'
        },
        {
            name: 'Statistics.blockedRequestsPercent',
            value: 0,
            color: '#777777',
            unit: '%'
        }
    ];

    const [devices, setDevices] = useState([
        { value: 'all', label: t('Statistics.allDevices') }
    ])

    const [loading, setLoading] = useState(false);
    const [globalStats, setGlobalStats] = useState(initialGlobaux);
    const [requestsLine, setRequestsLine] = useState([]);
    const [tagsPie, setTagsPie] = useState([]);
    const [topDomains, setTopDomains] = useState([]);
    const [topDevices, setTopDevices] = useState([]);

    const [filters, setFilters] = useState({
        device: "all",
        periode: 'last24h'
    })

    const [tags, setTags] = useState([]);


    useEffect(() => {
        asyncFetch();
    }, [id]);

    useEffect(() => {
        (async () => {
            var response = await kernel.api.get(`/dohzel/device/list?profileId=${id}`)
            if (response.error) {
                return
            }

            setDevices([
                { value: 'all', label: t('Statistics.allDevices') },
                ...response.data?.map(device => ({ value: device.id, label: device?.name ?? (`${DeviceTypes?.[device.deviceType] ?? ''} ${`v${device?.device?.browser?.os?.version?.trim() ?? ''} `}${device?.device?.browser?.device?.model ? `on ${device?.device?.browser?.device?.model ?? ''}` : ''}`) }))
            ])
        })()
    }, [id]);

    const asyncFetch = (periode = filters?.periode) => {
        (async () => {
            setLoading(true);

            const context = {}

            // fetch tags
            {
                const raw = await kernel.api.get('/threatdb/tags/list')
                if (raw.error) {
                    setTags({})
                }
                else {
                    context.tags = {}
                    if (Array.isArray(raw?.data)) {
                        raw.data.map((tag) => {
                            context.tags[tag.name] = tag
                        })
                    }
                    setTags(context.tags)
                }
            }

            // fetch request stats
            {
                const globaux = await kernel.api.get(`/dohzel/stats/requests?profileId=${id}&period=${periode}`)
                if (!globaux.error && Array.isArray(globaux?.data?.values)) {
                    // feed global stats
                    const _globalStats = [];
                    for (var clone of initialGlobaux)
                        _globalStats.push({ ...clone })

                    _globalStats[0].value = 0
                    _globalStats[1].value = 0
                    _globalStats[2].value = 0
                    for (var value of globaux?.data?.values) {
                        _globalStats[0].value += value[1]
                        _globalStats[1].value += value[2]
                    }
                    _globalStats[2].value = (_globalStats[1].value * 100 / _globalStats[0].value).toFixed(2);
                    setGlobalStats(_globalStats)

                    // prepare lines chart
                    const statTypes = {
                        all: {
                            name: "Statistics.requests",
                            color: statColors.all
                        },
                        blocking: {
                            name: "Statistics.blockedRequests",
                            color: statColors.blocking
                        },
                    }

                    const requests = []
                    Object.keys(statTypes).forEach((stat, index) => {
                        requests.push({
                            name: t(statTypes?.[stat]?.name),
                            data: globaux.data.values?.map(item => ([new Date(item[0]).getTime(), item[index + 1]])),
                            step: true,
                            color: statTypes?.[stat]?.color,
                            // visible: !disabled?.includes(stat) ?? true
                        })
                    });
                    setRequestsLine(requests)

                }
            }

            // fetch tags stats
            {
                const raw = await kernel.api.get(`/dohzel/stats/tags?profileId=${id}&period=${periode}`)
                if (!raw.error) {
                    // compute values
                    const values = {}

                    for (var pt of raw.data.values) {
                        const key = pt[1]
                        const ctag = context.tags[key]
                        if (!ctag)
                            continue
                        if (!values[key]) {
                            values[key] = {
                                name: ctag.name,
                                y: 0,
                                color: ctag.color
                            }
                        }
                        values[key].y += pt[2]
                    }

                    setTagsPie(Object.values(values))
                }
            }

            // fetch top domains
            {
                const raw = await kernel.api.get(`/dohzel/stats/top/domains?profileId=${id}&period=${periode}`)
                if (!raw.error) {
                    setTopDomains(raw.data.values)
                }
            }

            // fetch top devices
            {
                const raw = await kernel.api.get(`/dohzel/stats/top/devices?profileId=${id}&period=${periode}`)
                if (!raw.error) {
                    for (var key in raw.data.values) {
                        const value = raw.data.values[key]
                        value.deviceInfo = raw.data.devices[value.device]
                    }
                    setTopDevices(raw.data.values)
                }
            }

            setLoading(false);
        })()
    };


    const topDevicesColumns = [
        {
            title: t('Statistics.deviceName'),
            dataIndex: 'device',
            key: 'device',
            render: (text, record) => (
                <Link to={`/dohzel/device/${record.device}/statistics`}>
                    <Brands.BrandedDevice device={record.deviceInfo} />
                </Link>
            ),
        },
        {
            title: t('Statistics.dnsQueries'),
            dataIndex: 'count',
            key: 'count',
            sorter: (a, b) => a.count - b.count,
            defaultSortOrder: 'descend',
        },
        {
            title: t('Statistics.blocked'),
            dataIndex: 'blocked',
            key: 'blocked',
            sorter: (a, b) => a.blocked - b.blocked
        },
        {
            title: t('Statistics.security'),
            dataIndex: 'security',
            key: 'security',
            sorter: (a, b) => a.security - b.security
        },
    ];


    const topDomainsColumns = [
        {
            title: t('Statistics.domain'),
            dataIndex: 'domain',
            key: 'domain',
            render: (text, record) => (
                <ThreatDBIOC key={`${record.domain}-ioc`} kernel={kernel} value={record.domain} />
            ),
        },
        {
            title: t('Statistics.blocked'),
            dataIndex: 'count',
            key: 'count',
            sorter: (a, b) => a.count - b.count,
            defaultSortOrder: 'descend',
        }
    ];



    return (
        <>
            <DiventryBlock>
                <Space.Compact style={{ paddingBottom: 10 }}>
                    <Button onClick={() => {
                        asyncFetch();
                    }}>
                        {t(`Refresh`)}
                    </Button>

                    <Select
                        value={filters.periode}
                        style={{ minWidth: 200 }}
                        onChange={(key) => {
                            setFilters({ ...filters, periode: key });
                            asyncFetch(key);
                        }}
                        options={periodes}
                    />

                    {/* <Select
                        value={filters.device}
                        style={{ minWidth: 200 }}
                        onChange={(key) => {
                            setFilters({ ...filters, device: key })
                        }}
                        disabled={true}
                        options={devices}
                    /> */}
                </Space.Compact>

                <Row gutter={[16, 16]}>
                    {
                        globalStats?.length ?
                            <>
                                {globalStats.map((stat, index) => (
                                    <Col
                                        key={index}
                                        xs={24}   // 1 par ligne sur petit écran
                                        sm={12}   // 2 par ligne sur écran moyen
                                        md={8}    // 3 par ligne à partir de medium (md ≥ 768px)
                                    >
                                        <Card>
                                            <h1 style={{ ...styles.statName, color: stat.color }}>
                                                {new Intl.NumberFormat("fr-FR").format(stat.value)} {stat.unit}
                                            </h1>
                                            <span style={styles.statValue}>{t(`${stat.name}`)}</span>
                                        </Card>
                                    </Col>
                                ))}
                            </>
                            :
                            <div style={{ height: 400, paddingTop: 200, width: "100%", textAlign: "center" }}>
                                <Spin spinning={true} tip="Loading" size="large" />
                            </div>
                    }

                    <Col span={16}>
                        <Card style={{ ...styles.statContainer, textAlign: 'left' }}>
                            {loading === false ?
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={{
                                        chart: {
                                            type: 'spline'
                                        },
                                        title: null,
                                        xAxis: {
                                            type: 'datetime',
                                        },
                                        yAxis: {
                                            title: {
                                                text: 'Request'
                                            }
                                        },
                                        legend: {
                                            align: 'left',
                                            verticalAlign: 'top',
                                            borderWidth: 0
                                        },

                                        tooltip: {
                                            shared: true,
                                            crosshairs: true
                                        },
                                        plotOptions: {
                                            area: {
                                                fillOpacity: 0
                                            }
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        series: requestsLine
                                    }}
                                />
                                :
                                <div style={{ height: 400, paddingTop: 200, width: "100%", textAlign: "center" }}>
                                    <Spin spinning={true} tip="Loading" size="large" />
                                </div>
                            }

                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card style={{ ...styles.pieContainer, textAlign: 'left' }}>
                            {loading === false ?
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={{
                                        chart: {
                                            type: 'pie',
                                            options3d: {
                                                enabled: true,
                                                alpha: 45
                                            }
                                        },
                                        title: {
                                            text: '',
                                            align: 'left'
                                        },
                                        subtitle: {
                                            text: '',
                                            align: 'left'
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        plotOptions: {
                                            pie: {
                                                depth: 45
                                            }
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        series: [{
                                            name: t('Statistics.event'),
                                            data: tagsPie
                                        }],
                                    }}
                                />
                                :
                                <div style={{ height: 400, paddingTop: 200, width: "100%", textAlign: "center" }}>
                                    <Spin spinning={true} tip="Loading" size="large" />
                                </div>
                            }
                        </Card>
                    </Col>

                    <Col span={10}>
                        <Card
                            title={
                                <Typography.Title level={4}>{t('Statistics.topDomains')}</Typography.Title>
                            }
                            style={{ ...styles.tableContainer }}
                        >
                            {loading === false ?
                                <Table
                                    size="small"
                                    dataSource={topDomains}
                                    columns={topDomainsColumns}
                                    // loading={loading}
                                    pagination={false}
                                    rowKey="domain"
                                />
                                :
                                <div style={{ height: 400, paddingTop: 200, width: "100%", textAlign: "center" }}>
                                    <Spin spinning={true} tip="Loading" size="large" />
                                </div>
                            }
                        </Card>
                    </Col>

                    <Col span={14}>
                        <Card
                            title={
                                <Typography.Title level={4}>{t('Statistics.topDevices')}</Typography.Title>
                            }
                            style={{ ...styles.tableContainer }}
                        >
                            {loading === false ?
                                <Table
                                    size="small"
                                    dataSource={topDevices}
                                    columns={topDevicesColumns}
                                    // loading={loading}
                                    pagination={false}
                                    rowKey="device"
                                />
                                :
                                <div style={{ height: 400, paddingTop: 200, width: "100%", textAlign: "center" }}>
                                    <Spin spinning={true} tip="Loading" size="large" />
                                </div>
                            }
                        </Card>
                    </Col>

                </Row>
            </DiventryBlock>
        </>
    )
}

const styles = {
    filters: {
        marginTop: 20
    },
    statContainer: {
        // marginTop: 25,
        textAlign: 'center'
    },
    pieContainer: {
        // marginTop: 25,
        textAlign: 'center'
    },
    tableContainer: {
        textAlign: 'left'
    },
    statName: {
        marginBottom: '-0.2em',
        fontWeight: 800
    },
    statValue: {
        color: '#777777',
        fontSize: '18px'
    }
}
